import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';

import Skeleton from 'components/Skeleton';
import { SSRSeparator } from './SSRSeparator';

/**
 * @param {object} props
 * @param {import('utils/types').BreadcrumbItem[]} [props.items=[]]
 * @param {string} [props.separator='>']
 */
export default function Breadcrumb({ items = [], separator = '>' }) {
  if (!_isArray(items) || _isEmpty(items)) return null;

  const listItems = items.map((item, index) => {
    const { label, onClick, loading = false, shepherdId } = item;
    return (
      <li
        key={uuidv4()}
        className="customBreadcrumb--item"
        data-separator={separator}
        data-shepherd={shepherdId}
      >
        {loading ? (
          <Skeleton width="100px" height="16px" className="mb-0" />
        ) : (
          <span
            role="button"
            onClick={onClick}
            data-disabled={loading || !onClick}
            className="customBreadcrumb--item__button"
          >
            {label}
          </span>
        )}
        {index < items.length - 1 && <SSRSeparator />}
      </li>
    );
  });

  return <ul className="customBreadcrumb">{listItems}</ul>;
}
